import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoggingService } from '../../services/logging.service';
import { Subscription } from 'rxjs';
import { User } from '../../models/user';
import { HrDashboardService } from '../../services/hr-dashboard.service';
import { AppUser, AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-hr-dashboard',
  standalone: false,
  templateUrl: './hr-dashboard.component.html',
  styleUrl: './hr-dashboard.component.scss'
})
export class HrDashboardComponent implements OnInit, OnDestroy {

  userId !: number;
  userRole !: string;
  userSubscription !: Subscription;
  user: User = new User();
  @Input() tenantId!: number; 
  hrId!: number;
  

  constructor(private loggingService: LoggingService,
    private hrDashboardService: HrDashboardService,
    private authService: AuthService ) { }

  ngOnInit(): void {
    this.loggingService.logDebug("Getting the userId from session storage");
    const userid = sessionStorage.getItem('user_id');
    if (userid) {
      this.userId = parseInt(userid, 10);
    }
    this.loggingService.logDebug("Getting the userrole from session storage");
    const userrole = sessionStorage.getItem('user_role');
    if (userrole) {
      this.userRole = userrole;
    }
    this.loggingService.logDebug("Getting the hrId from session storage");
    const hrid = sessionStorage.getItem('hr_id');
    if (hrid) {
       this.hrId = parseInt(hrid, 10);
    }

    this.userSubscription = this.hrDashboardService.getAllHrDetails(
      this.userId, this.userRole).subscribe((user) => {
        this.user = user;
        const appUser: AppUser = {
          UserID: user.UserID,
          Name: user.Name,
          Email: user.Email,
          IsActive: user.IsActive,
          personType: this.mapPersonType(user.personType)
        };

        this.authService.setCurrentUser(appUser);

        if (user.hr) {
          sessionStorage.setItem('hr_id', user.hr.hrId.toString());
          this.hrId = user.hr.hrId; 
    }

        if (user.hr && user.hr.tenantId) {
          this.tenantId = user.hr.tenantId;  // <-- dynamic tenantId
      }
 });

  }

  private mapPersonType(value: string): 'user' | 'manager' | 'hr' {
    const allowedTypes = ['user', 'manager', 'hr'];
    return allowedTypes.includes(value) ? (value as 'user' | 'manager' | 'hr') : 'user';
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

}
